import { get } from './apiClient';
import { urls, imageUrl, PLACEHOLDER_IMAGE } from './urlService';

export async function getPopularCategories() {
  return get(urls.popularCategories);
}

export async function getCategoryTree() {
  return get(urls.categoryTree);
}

export async function getCategoriesByType(type) {
  return get(urls.categoriesByType(type));
}

export function categoryImageUrl(cat) {
  return imageUrl(cat.image) || PLACEHOLDER_IMAGE;
}

export function categoryHref(cat) {
  const slug = cat.slug || cat.name?.toLowerCase().replace(/[^a-z0-9]+/g, '-') || '#';
  return '/' + slug;
}

export function toMenuItems(tree) {
  return tree.map(cat => ({
    label: cat.name,
    image: imageUrl(cat.image),
    submenu: (cat.subcategories || []).map(sub => ({
      label: sub.name,
      href: categoryHref(sub),
    })),
  }));
}
